export const CAR_FIELDS = [  
  { key: "brand", label: "brand" },
  
  { key: "type", label: "type" },
  
  { key: "year_build", label: "year_build" },
  
  { key: "current_nr_km_driven", label: "current_nr_km_driven", type: 'number' },
  
  { key: "seats_number", label: "seats_number", type: "number" },
  
  { 
    key: "tow_bar",
    label: "tow_bar",
    type: "fixed-select",
    options: [
      {label: "Yes", value: true},
      {label: "No", value: false}
    ]
  },
  
  { 
    key: "status",
    label: "status",
    type: "fixed-select",
    options: [
      {label: "Available", value: "available"},
      // {label: "In Use", value: "in use"},
      {label: "In Repair", value: "in repair"},
      {label: "Broken", value: "broken"},
    ]
  },
  
  { key: "cost_per_day", label: "cost_per_day" },
  
  { key: "cost_of_private_use", label: "cost_of_private_use" },
  
  { key: "insurance_number", label: "insurance_number (amount per kilometer)" },
  
  { key: "insurance_cost", label: "insurance_cost" },
  
  { key: "tax", label: "tax" },
  
  { key: "picture", label: "picture", type: "file" },
]

export const CAR_REQUIRED_FIELDS = [
  { key: "license_plate", label: "license_plate" }
];

export const FIELDS = [...CAR_REQUIRED_FIELDS, ...CAR_FIELDS]


export const INFO_FIELDS = [
  { key: "license_plate", label: "License Plate" },
  { key: "brand", label: "Brand" },
  { key: "type", label: "Type" },
  { key: "year_build", label: "Year Build" },
  { key: "tow_bar", label: "Tow Bar" },
  { key: "status", label: "Status" },
  { key: "seats_number", label: "Seats Number" },
  { key: "cost_per_day", label: "Cost Per Day", type: 'price' },
  { key: "cost_of_private_use", label: "Cost Of Private Use", type: 'price' },
  { key: "tax", label: "Tax", type: 'price'  },
  { key: "current_nr_km_driven", label: "Current Nr Km Driven" },
  { key: "insurance_cost", label: "Insurance Cost", type: 'price' },
  { key: "insurance_number", label: "Insurance Number" },
];
